import { Injectable } from '@angular/core';
import { BaseDAO } from './baseDAO';
import { ConstantMan } from '../constantMan';
import { ApiHelper } from '../apiHelper';
import { Observable } from 'rxjs/Rx';
import { CharterNote } from 'anchor-shared/lib/model/entity/charterNote';
import { HttpHeaders } from '@angular/common/http';
import { PaymentIntent } from '@stripe/stripe-js/types/api/payment-intents';
import { Payment } from 'anchor-shared/lib/model/entity/payment';

@Injectable()
export class CharterPaymentDAO extends BaseDAO<string> {
  constructor(public readonly apiHelper: ApiHelper) {
    super(apiHelper, ConstantMan.API.RESOURCE.CHARTER_PAYMENTS);
  }

  // Returns stripe payment intent
  public createPaymentIntent(
    charterId: number,
  ): Observable<{ paymentIntent: PaymentIntent; payment: Payment }> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/create-payment-intent';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      charterId: charterId,
    };
    return this.apiHelper.apiCall<{
      paymentIntent: PaymentIntent;
      payment: Payment;
    }>(url, method, null, data, headers);
  }

  // Returns stripe setup intent
  public createCharterPaymentIntent(): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/create-payment-method';
    const method = 'GET';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    return this.apiHelper.apiCall<any>(url, method, null, null, headers);
  }

  public createAdminPaymentIntent(
    charterId: number,
    userId: number,
    paymentAmount: string,
    paymentTitle: string,
    paymentDescription: string,
  ): Observable<PaymentIntent> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/admin-create-payment-intent';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      charterId: charterId,
      userId: userId,
      paymentAmount: paymentAmount,
      paymentTitle: paymentTitle,
      paymentDescription: paymentDescription,
    };
    return this.apiHelper.apiCall<PaymentIntent>(
      url,
      method,
      null,
      data,
      headers,
    );
  }

  sendFailedPaymentEmailToCustomer(
    userId: number,
    failedAmount: string,
    paymentIntentId: string,
  ): Observable<any> {
    const url: string =
      this.apiHelper.getServiceName() +
      this.getResource() +
      '/send-failed-payment-request';
    const method = 'POST';
    const headers: HttpHeaders = this.apiHelper.getDefaultHeader();
    const data = {
      userId: userId,
      failedAmount: failedAmount,
      paymentIntentId: paymentIntentId,
    };
    return this.apiHelper.apiCall<PaymentIntent>(
      url,
      method,
      null,
      data,
      headers,
    );
  }
}
